import { Injectable, signal } from '@angular/core';

import { FieldInterventionEntity } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class UpdateFieldInterventionService {
    public readonly progressTotal = signal<number>(0);
    public readonly progressValue = signal<number>(0);
    public readonly updatedEntities = signal<FieldInterventionEntity[]>([]);

    public incrementProgress(value = 1): void {
        this.progressValue.update((count: number) => count + value);
    }

    public resetProgress(): void {
        this.progressTotal.set(0);
        this.progressValue.set(0);
    }

    public startProgress(total: number): void {
        this.progressTotal.set(total);
        this.progressValue.set(0);
    }
}
